import React from "react";
import { Box } from "@material-ui/core";
import { Typography } from "components/common";
import ApplicationIcon from "./ApplicationIcon";
import { makeStyles } from "@material-ui/styles";
import { getPlatformNameById } from "../../../../constants";

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.common.white,
    "& svg path": {
      fill: theme.palette.common.white,
    },
  },
}));

const ApplicationSquareButton = ({ applicationType, ...props }) => {
  const classes = useStyles();
  return (
    <Box
      width="160px"
      height="160px"
      display="flex"
      borderRadius="borderRadius"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      className={classes.icon}
      {...props}
    >
      <ApplicationIcon applicationType={applicationType} size="md" />
      <Typography variant="body1Medium">
        {getPlatformNameById(applicationType)}
      </Typography>
    </Box>
  );
};

export default ApplicationSquareButton;
